'use client'

import { useSavedOrders } from '@/lib/hooks/use-saved-orders'

import { OrdersList } from '@/components/molecules'
import { OrdersPlaceholder } from '@/components/placeholders'
import { LoadingDots, ScrollArea } from '@/components/ui'

export const SavedOrdersContent = () => {
  const { data: carts, isLoading, error } = useSavedOrders()

  return (
    <div className="flex h-[calc(var(--inner-layout-height))] w-full flex-col gap-4 lg:pt-4">
      <div className="flex items-center justify-between">
        <div className="flex w-full flex-row items-center justify-between">
          <h2 className="text-lg font-medium">Saved orders</h2>
          <span className="text-sm text-gray-700">
            {isLoading ? '...' : `${carts?.length ?? 0} Total orders`}
          </span>
        </div>
      </div>

      <ScrollArea className="flex h-full w-full flex-col gap-12 rounded-lg border border-gray-100 bg-white p-4 shadow-card lg:p-6 dark:border-0 dark:bg-gray-900/20">
        {isLoading && (
          <div className="flex h-full w-full items-center justify-center">
            <LoadingDots />
          </div>
        )}

        {error && (
          <div className="flex h-full w-full items-center justify-center">
            <p className="text-sm text-red-600">
              Failed to load saved orders. Please try again.
            </p>
          </div>
        )}

        {!isLoading && !error && carts?.length === 0 && <OrdersPlaceholder />}
        {!isLoading && !error && carts?.length !== 0 && (
          <OrdersList data={carts ?? []} />
        )}
      </ScrollArea>
    </div>
  )
}

